import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React, { useRef, useEffect } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import QRious from 'qrious';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["id", "background", "backgroundAlpha", "className", "foreground", "foregroundAlpha", "level", "mime", "padding", "size", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var QrCode$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      background = _ref.background,
      backgroundAlpha = _ref.backgroundAlpha,
      className = _ref.className,
      foreground = _ref.foreground,
      foregroundAlpha = _ref.foregroundAlpha,
      level = _ref.level,
      mime = _ref.mime,
      padding = _ref.padding,
      size = _ref.size,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  var dataAttributes = useDataAttributes(rest);
  var qrRef = useRef(ref);
  useEffect(function () {
    // eslint-disable-next-line
    new QRious({
      background: background,
      backgroundAlpha: backgroundAlpha,
      element: qrRef.current,
      foreground: foreground,
      foregroundAlpha: foregroundAlpha,
      level: level,
      mime: mime,
      padding: padding,
      size: size,
      value: value
    });
  }, [background, backgroundAlpha, foreground, foregroundAlpha, level, mime, padding, size, value]);
  return /*#__PURE__*/jsx("canvas", _objectSpread({
    id: id,
    ref: qrRef,
    className: "gz-qr-code ".concat(className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, dataAttributes));
});
QrCode$1.COMPONENT_ID = 'Gearz.QrCode';
QrCode$1.displayName = QrCode$1.COMPONENT_ID;
QrCode$1.propTypes = {
  id: PropTypes.stringWithDescription('Id of the qr code.'),
  background: PropTypes.stringWithDescription('Background color of the qr code.'),
  backgroundAlpha: PropTypes.numberWithDescription('Alpha of the background color of the qr code.'),
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  foreground: PropTypes.stringWithDescription('Foreground color of the qr code.'),
  foregroundAlpha: PropTypes.numberWithDescription('Alpha of the foreground color of the qr code.'),
  level: PropTypes.oneOfWithDescription(['L', 'M', 'Q', 'H'], 'Error correction level of the qr code.'),
  mime: PropTypes.oneOfWithDescription(['image/png', 'image/jpeg'], 'MIME type used to render the image of the qr code.'),
  padding: PropTypes.numberWithDescription('Padding (in pixels) of the qr code.'),
  size: PropTypes.numberWithDescription('Size (in pixels) of the qr code.'),
  value: PropTypes.stringWithDescription('Value encoded within the qr code.').isRequired
};
QrCode$1.defaultProps = {
  id: null,
  background: '#fff',
  backgroundAlpha: 1.0,
  className: '',
  foreground: '#000',
  foregroundAlpha: 1.0,
  level: 'L',
  mime: 'image/png',
  padding: null,
  size: 100
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var QrCode = styled(QrCode$1).withConfig({
  componentId: "gz-qr-code-1673535257587__sc-192b1ie-0"
})(["", ""], function (props) {
  return getThemeByProps({
    componentId: QrCode$1.COMPONENT_ID,
    props: props
  });
});
QrCode.displayName = QrCode$1.displayName;
QrCode.propTypes = QrCode$1.propTypes;
QrCode.defaultProps = QrCode$1.defaultProps;

export { QrCode as Q };
